import type { VisionWidget } from '@/components/VisionAi/widgets/visionWidget.types';

export interface Conversation {
  id: string | number;
  name?: string;
  createdAt: string;
}

export enum ChatMessageRole {
  User = 'user',
  Assistant = 'assistant',
}

export interface ChatMessage {
  id: string | number;
  role: ChatMessageRole;
  text: string;
  timestamp: Date;
  isWarningMessage?: boolean;
  errorCode?: string | null;
  isLoading?: boolean;
  intentType?: string;
  /** UNIFIED additional_content widgets for inline/below rich content. */
  widgets?: VisionWidget[];
}

/** Vision AI message shape from `visionAiMessagesStore`. */
export interface VisionAiStoreMessage {
  id: string | number;
  sender: string;
  message?: string | null;
  createdAt: string;
  intentType?: string;
  errorCode?: number | string | null;
  isWarningMessage?: boolean;
  additionalContent?: unknown;
  conversationId: string | number | null;
}
